export enum AreaUnit {
  ac = 'ac',
  ha = 'ha',
}
